import React from 'react';
import { Box } from '@mui/material';

import { useResize } from 'hooks/common';
import MainAuthScreenWrapper from '../MainAuthScreenWrapper';
import { SparkImageLoader } from 'sharedComponents/UI';
import AddWorkspaceDialogContent from 'components/Dashboard/Modals/AddWorkspaceDialogContent';
import { useNavigate } from 'react-router-dom';
import { SPARK_ROUTES } from 'constants/routes';

function Onboarding() {
  const { isMobile } = useResize();
  const navigate = useNavigate();
  const handleCallback = () => {
    navigate(SPARK_ROUTES.DASHBOARD);
  };

  return (
    <MainAuthScreenWrapper>
      <Box
        width={'100%'}
        display={'flex'}
        justifyContent={'center'}
        alignContent={'center'}
        mb={3}
      >
        <a href='https://sparkup.ai/'>
          <SparkImageLoader
            src='SparkLogo.svg'
            alt='spark-logo'
            height={isMobile ? 46 : 58}
            
          />
        </a>
      </Box>

      <AddWorkspaceDialogContent
        renderWelcomeText={true}
        callBack={handleCallback}
      />
    </MainAuthScreenWrapper>
  );
}

export default Onboarding;
